import MaterialTable from "material-table";
import React, { useState, useEffect } from "react";
import tableIcons from "../../components/TableIcon";
import krLoacale from "date-fns/locale/ko";
import { makeStyles } from "@material-ui/core/styles";
import storeAction from "../../stores/ipStore";

import { useAlert } from "react-alert";
const useStyles = makeStyles((theme) => ({
  card: {
    textAlign: "center",
  },
}));

const ipCol = [
  {
    title: "ip주소",
    field: "ipaddress",
    cellStyle: {
      textAlign: "center",
    },
    editable: "onAdd",
  },
  {
    title: "사용자",
    field: "name",
    cellStyle: {
      textAlign: "center",
    },
  },
];

function IpList(props) {
  const { list } = props.store;
  const alert = useAlert();
  useEffect(() => {
    async function getList() {
      await storeAction.getList();
    }
    getList();
  }, []);

  return (
    <MaterialTable
      title="사내IP 현황"
      icons={tableIcons}
      data={list}
      columns={ipCol}
      localization={{
        header: {
          actions: "수정",
        },
        toolbar: {
          exportTitle: "내보내기",
          exportAriaLabel: "라벨",
          searchPlaceholder: "검색",
          searchTooltip: "검색",
          exportName: "엑셀로 내보내기",
          exportCSVName: "엑셀로 내보내기",
        },
        body: {
          editRow: {
            deleteText: "복구는 불가능 합니다. 삭제하시겠습니까?",
          },
          editTooltip: "수정",
          deleteTooltip: "삭제",
          addTooltip: "추가",
          dateTimePickerLocalization: krLoacale,
        },
      }}
      options={{
        sorting: true,
        addRowPosition: "first",
        headerStyle: { textAlign: "center" },
      }}
      editable={{
        onRowUpdate: (newData, oldData) =>
          new Promise((resolve) => {
            (async () => {
              try {
                await storeAction.updateIp(newData);
                resolve();
              } catch (e) {
                alert.show(e.message);
                resolve();
              }
            })();
          }),
        onRowAdd: (newData, oldData) =>
          new Promise((resolve) => {
            (async () => {
              try {
                await storeAction.addIp(newData);
                resolve();
              } catch (e) {
                alert.show(e.message);
                resolve();
              }
            })();
          }),
        onRowDelete: (newData, oldData) =>
          new Promise((resolve) => {
            (async () => {
              try {
                await storeAction.deleteIp(newData);
                resolve();
              } catch (e) {
                alert.show(e.message);
                resolve();
              }
            })();
          }),
      }}
    />
  );
}

export default IpList;
